import {
  AlertBanner,
  AlertContent,
  AlertTitle,
  type AlertBannerProps,
} from "#ui/alert";

import type { UseQueryPageOutageData } from "./use-query-page-outage";

export type PageOutageAlertBannerProps = Omit<AlertBannerProps, "intent"> & {
  data: UseQueryPageOutageData;
};

/**
 * Renders an alert banner for the page outage status.
 * If the outage data indicates that the page is available and has a status message,
 * it displays the message in a warning alert banner.
 * Otherwise, it returns null.
 */
export function PageOutageAlertBanner({
  data,
  ...props
}: PageOutageAlertBannerProps) {
  if (!data || data.isAvailable !== true || !data.statusMessage?.trim()) {
    return null;
  }

  return (
    <AlertBanner {...props} intent="warning">
      <AlertContent>
        <AlertTitle>{data.statusMessage}</AlertTitle>
      </AlertContent>
    </AlertBanner>
  );
}
